import { Market } from "../../../../../../../types/workspace";
import { useMarketSummary } from "../../../../../hooks/useMarketSummary";
import { useWorkspaceStore } from "../../../../../../../store/workspace/WorkspaceStore";
import { useCompetitorPresenceFilters } from "./useCompetitorPresenceFilters";

export const useCompetitorCustomerCounts = () => {
  const workspace = useWorkspaceStore((state) => state.draft);
  const localizeInstalls = useWorkspaceStore(
    (state) => state.draft?.configuration?.localizeInstalls ?? true
  );

  const tam = useMarketSummary({
    companyFilters: useCompetitorPresenceFilters(workspace, Market.TAM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  const sam = useMarketSummary({
    companyFilters: useCompetitorPresenceFilters(workspace, Market.SAM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  const som = useMarketSummary({
    companyFilters: useCompetitorPresenceFilters(workspace, Market.SOM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  return {
    loading: tam.loading || sam.loading || som.loading,
    competitorTam: tam.companyCount,
    competitorSam: sam.companyCount,
    competitorSom: som.companyCount,
  };
};
